module.exports = __webpack_public_path__ + "static/img/2_1_2_1.294a8cd5.jpg";